import { Stack, Typography } from "@mui/material";

interface InfoRowProps {
  label: string;
  value: string;
}

export default function InfoRow({ label, value }: InfoRowProps) {
  return (
    <Stack direction="row" spacing={0.5}>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          color: "text.secondary",
          width: 106,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "15px",
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
}
